<template>
    <div class="service-box">
        <div class="topCenter-bx">
            <h3 class="caption">{{serviceData.caption}}</h3>
            <p class="center">{{serviceData.center}}</p>
        </div>
        <div class="center-box">
            <div class="item-box" v-for='(item,index) in serviceData.itemData' :key='index' @click='playMove(item)'>
                <div class="imgbox" :style='{backgroundImage:"url("+item.imgurl+")"}'>
                    <div id="playBtn" class="circle" style="margin: 20px 0px 10px 20px;">
                        <div class="circle_inner_play">
                        </div>
                    </div>
                </div>
                <h5 class="item-caption">{{item.caption}}</h5>
            </div>
        </div>
        <el-dialog :title="movename" :visible.sync="dialogFormVisible" :width='move' destroy-on-close>
            <iframe :src="moveUrl" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"
                class="videomove"> </iframe>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'Service',
        props: {
            serviceData: Object
        },
        data() {
            return {
                move: undefined,
                dialogFormVisible: false,
                movename: '',
                moveUrl: ''
            }
        },
        mounted() {
            this.getWidth()
        },
        methods: {
            playMove(it) {//弹出视频框
                if (it.video) {
                    this.moveUrl = it.video
                    this.movename = it.caption
                    this.dialogFormVisible = !this.dialogFormVisible
                }
            },
            getWidth() {//获取设备的宽度
                const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                windowWidth < 995 ? this.move = '100%' : this.move = '70%'

            }
        }
    }
</script>
<style scoped>
    .topCenter-bx {
        width: 100%;
        height: auto;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/stock-photo-72684347.jpg') no-repeat center;
        background-attachment: fixed;
        background-size: cover;
    }

    .caption {
        font-size: 80px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 5px;
        text-align: center;
        padding: 167px 0 39px 0;
    }

    .center {
        margin: 0 auto;
        max-width: 650px;
        font-size: 16px;
        font-weight: bold;
        line-height: 40px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        padding-bottom: 10%;
    }

    .center-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 16px;
        grid-row-gap: 72px;
        width: 85.4%;
        margin: 0 auto;
        transform: translateY(-10%);
    }

    .item-box {
        background-color: #ffffff;
    }

    .imgbox {
        width: 100%;
        height: 19.0vw;
        background: #666666 no-repeat center center;
        background-size: cover;
        position: relative;
    }

    .item-caption {
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(102, 102, 102, 1);
        letter-spacing: 5px;
        text-align: center;
        padding: 25px 0;
    }

    .videomove {
        width: 100%;
        height: 600px;
    }

    /* ============================================================================播放按钮=============================== */
    .circle{
        display: none;
    }

    .circle {
        border: solid 1px #333;
        border-radius: 50px;
        background-color: #333;
        height: 50px;
        position: absolute;
        bottom: 0;
        width: 50px;
        transition: all 0.5s;
    }

    .circle:hover {
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
        -moz-transform: scale(1.1);
    }


    .circle_inner_play {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 0 10px 20px;
        border-color: transparent transparent transparent #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -10px 0 0 -7px;
    }

    @media(max-width: 995px) {
        .topCenter-bx {
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/stock-photo-72684347.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
            position: relative;
        }

        .topCenter-bx::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .3);
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
        }

        .caption {
            font-size: 24px;
            letter-spacing: 5px;
            padding: 5% 0;
            position: relative;
            z-index: 3;
        }

        .center {
            position: relative;
            z-index: 3;
        }

        .center-box {
            grid-template-columns: 1fr;
            grid-column-gap: 0px;
            grid-row-gap: 0%;
            width: 100%;
            transform: translateY(0%);
        }

        .imgbox {
            height: 50vw;
        }

        .item-caption {
            font-size: 16px;
            line-height: 137.5%;
            padding: 5% 0;
        }
    }

    /* @media(max-width: 1023px) {
        .caption {
            color: rgba(36, 136, 248, 1);
        }

        .center {
            max-width: 80%;
            font-size: 50px;
            font-weight: normal;
            color: #000000;
            line-height: 250%;
        }

        .topCenter-bx {
            height: 1000px;
            background-attachment: initial;
        }

        .center-box {
            grid-template-columns: 1fr;
            width: 90%;
            transform: translateY(-95px);
        }

        .imgbox {
            height: 966px;
        }
        .item-caption {
        font-size: 50px;
        line-height: 137%;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/service.vue